<div class="page" [appLoadingAnimation]="isOrderDataLoading" [attr.data-test]="'feature-orderThankYouPage'">
  @if (orderData(); as orderData) {
    <div class="page-top">
      <div class="page-top__left">
        <div class="page-top__left--header">
          <h4 [attr.data-test]="'title-thankYou'">{{ 'order-thank-you-page.title' | translate }}</h4>
          <p class="description" [attr.data-test]="'desc-yourOrderHasBeenReceived'">
            @if (isPersonalOrder()) {
              {{
                  'order-thank-you-page.description-personal-success' | translate: {
                    orderNumber: orderReference | removeLeadingZero
                  }
              }}
              @if (isExternalQuoteCheckoutEnabled) {
                {{
                    'order-thank-you-page.return-to-tpf' | translate
                }}
              }
            } @else {
              {{
                  'order-thank-you-page.description-approval-success' | translate:{
                    name: customerFullName(),
                    orderNumber: orderReference | removeLeadingZero
                  }
              }}
            }
          </p>
        </div>
        @if (isSapP40Enabled) {
          <app-sap-message-controller [messages]="orderData.sapMessages ?? []"/>
        }
      </div>
      <div class="page-top__right">
        <div class="page-top__right--header">
          <h4 [attr.data-test]="'title-haveQuestions'">
            {{ 'order-thank-you-page.question.title' | translate }}
          </h4>
          <p class="description" [attr.data-test]="'desc-haveQuestions'">
            {{ 'order-thank-you-page.question.description' | translate }}
          </p>
        </div>
        <div class="page-top__right--footer">
          @if ('order-thank-you-page.question.phone' | translate; as phone) {
            <div class="contact">
              <span class="icon-phone"></span>
              <a [href]="'tel:' + phone"
                 [attr.data-test]="'desc-contactPhone'">
                {{ phone }}
              </a>
            </div>
          }
          @if ('order-thank-you-page.question.email' | translate; as email) {
            @if ('order-thank-you-page.question.email-label' | translate; as emailLabel) {
              <p class="contact-label">{{ emailLabel }}</p>
            }
            <div class="contact">
              <span class="icon-email"></span>
              <a [href]="'mailto:' + email"
                 [attr.data-test]="'desc-contactEmail'">
                {{ email }}
              </a>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="page-middle">
      <h5>{{ 'order-thank-you-page.ordered-items' | translate }}</h5>
      <div class="page-middle__container">
        <app-accordion>
          <ng-container ngProjectAs="[slot][header]">
            <div class="accordion__header accordion__title icon-arrow-down"
                 [attr.data-test]="'desc-toggleOrderedItemsAccordion'">
              <div class="column">
                <span class="column__label" [attr.data-test]="'label-orderId'">
                  {{ 'order-thank-you-page.order' | translate }}
                </span>
                <span [attr.data-test]="'desc-orderId'">{{ orderReference | removeLeadingZero }}</span>
              </div>
              <div class="column">
                <span class="column__label" [attr.data-test]="'label-orderedOn'">
                  {{ 'order-thank-you-page.ordered-on' | translate }}
                </span>
                <span [attr.data-test]="'desc-orderedOn'">
                  {{ orderData.createdAt | formatDate }}
                </span>
              </div>
              <div class="column">
                <span class="column__label" [attr.data-test]="'label-totalQuantity'">
                  {{ 'order-thank-you-page.total-quantity' | translate }}
                </span>
                <span [attr.data-test]="'desc-totalQuantity'">
                  {{ orderData.itemsTotalNumber }} {{ UiUtils.singularOrPlural(orderData.itemsTotalNumber ?? 0, 'order-thank-you-page.total-item-number') | translate }}
                </span>
              </div>
              <div class="column column__right">
                <span class="column__label" [attr.data-test]="'label-totalSum'">
                  {{ 'order-thank-you-page.total-sum' | translate }}
                </span>
                <span [attr.data-test]="'desc-totalSum'">
                  {{ orderData.totals?.grandTotal | currency: orderData.currencyIsoCode }}
                </span>
              </div>
            </div>
          </ng-container>
          <ng-container ngProjectAs="[slot][panel]">
            <div class="container accordion__content">
              <div class="items" [attr.data-test]="'order-items'">
                @if (priceFields.length > 0) {
                  <div class="detailed-price-info__container">
                    <h5 class="detailed-price-info__title" [attr.data-test]="'label-priceDetailsTitle'">
                      {{ 'order-thank-you-page.price-details-title' | translate }}
                    </h5>
                    @if (priceFields.includes(EThankYouPagePriceFieldNames.SUBTOTAL)) {
                      <div class="detailed-price-info__element subtotal">
                        <div class="text-align-left" [attr.data-test]="'label-subtotal'">
                          {{ 'order-thank-you-page.price-details.subtotal' | translate }}
                        </div>
                        <div class="text-align-right" [attr.data-test]="'value-subtotal'">
                          {{ orderData.totals?.subtotal | currency: orderData.currencyIsoCode }}
                        </div>
                      </div>
                    }
                    @if (priceFields.includes(EThankYouPagePriceFieldNames.EXPENSE)) {
                      <div class="detailed-price-info__element">
                        <div class="text-align-left" [attr.data-test]="'label-shippingHandlingCost'">
                          {{ 'order-thank-you-page.price-details.shipping-handling-cost' | translate }}
                        </div>
                        <div class="text-align-right" [attr.data-test]="'desc-shippingHandlingCost'">
                          {{ orderData.totals?.expenseTotal | currency: orderData.currencyIsoCode }}
                        </div>
                      </div>
                    }
                    @if (priceFields.includes(EThankYouPagePriceFieldNames.TAX)) {
                      <div class="detailed-price-info__element">
                        <div class="text-align-left" [attr.data-test]="'label-gst'">
                          {{ 'order-thank-you-page.price-details.gst' | translate }}
                        </div>
                        <div class="text-align-right" [attr.data-test]="'desc-gst'">
                          {{ orderData.totals?.taxTotal | currency: orderData.currencyIsoCode }}
                        </div>
                      </div>
                    }
                    @if (priceFields.includes(EThankYouPagePriceFieldNames.DISCOUNTS) && discounts().length > 0) {
                      @for (discount of discounts(); track discount.voucherCode) {
                        <div class="detailed-price-info__element">
                          <div class="text-align-left" [attr.data-test]="'label-discount'">
                            <span>{{ 'order-thank-you-page.price-details.discount' | translate }}</span>
                            @if (!isSapStore) {
                              <span> {{ discount.displayName }} - {{ discount.voucherCode }}:</span>
                            } @else {
                              <span> {{ discount.displayName }}:</span>
                            }
                          </div>
                          <div class="text-align-right" [attr.data-test]="'value-discount'">
                            - {{ discount.sumAmount | currency: orderData.currencyIsoCode }}
                          </div>
                        </div>
                      }
                    }
                    <div class="detailed-price-info__element total-sum">
                      <div class="text-align-left" [attr.data-test]="'label-totalSum'">
                        {{ 'order-thank-you-page.price-details.total-sum' | translate }}
                      </div>
                      <div class="text-align-right" [attr.data-test]="'desc-totalSum'">
                        {{ orderData.totals?.grandTotal | currency: orderData.currencyIsoCode }}
                      </div>
                    </div>
                    @if (shouldTdsBeShown()) {
                      <div class="detailed-price-info__element">
                        <div class="text-align-left" [attr.data-test]="'label-paidAmount'">
                          {{ 'order-thank-you-page.price-details.paid-amount' | translate }}
                        </div>
                        <div class="text-align-right" [attr.data-test]="'desc-paidAmount'">
                          {{ orderData.totals?.priceToPay | currency: orderData.currencyIsoCode }}
                        </div>
                      </div>
                      <div class="detailed-price-info__element">
                        <div class="text-align-left" [attr.data-test]="'label-TDS'">
                          {{ 'order-thank-you-page.price-details.tds' | translate }}
                        </div>
                        <div class="text-align-right" [attr.data-test]="'desc-TDS'">
                          {{ tdsExpense() | currency: orderData.currencyIsoCode }}
                        </div>
                      </div>
                    }
                    @if ('order-thank-you-page.pricing-msg' | translate; as pricingMessage) {
                      <div class="pricing-msg" [attr.data-test]="'desc-pricingMsg'">
                        {{ pricingMessage }}
                      </div>
                    }
                  </div>
                }
                @for (item of orderData.items; track item.sku) {
                  <div class="item" [attr.data-test]="'order-item-' + item.name">
                    <img class="item__image"
                         [src]="ImageUtils.addPreset(item.metadata?.image, ImagePreset.Default)"
                         [alt]="item.name ?? 'n/a'"
                         [attr.data-test]="'image-item-img'">
                    <div class="item__content">
                      <div class="item__header">
                        @if (isProductTagsActive) {
                          <div class="item__tags">
                            @if (isDiscontinuedStatusEnabled && item.isDiscontinued) {
                              <span class="label discontinued-item"
                                    [attr.data-test]="'desc-flag-discontinued'">
                              {{ 'order-thank-you-page.discontinued-item' | translate }}
                            </span>
                            }
                            @if (item.isExchangeable || item.sapDetails?.exchangeableItem) {
                              <span class="label exchangeable-item"
                                    [attr.data-test]="'desc-flag-exchangeable'">
                              {{ 'order-thank-you-page.exchangeable-item' | translate }}
                            </span>
                            }
                            @if (item.heavyweight) {
                              <span class="label heavyweight-item"
                                    [attr.data-test]="'desc-flag-heavyweight'">
                              {{ 'order-thank-you-page.heavyweight-item' | translate }}
                            </span>
                            }
                          </div>
                        }
                        <h6 class="item__name" [attr.data-test]="'desc-item-name'">
                          <a [routerLink]="['/product/', `A_${item?.materialNumber}`]">{{ item?.name }}</a>
                        </h6>
                        <p [attr.data-test]="'desc-item-sku'">{{ item?.materialNumber }}</p>
                      </div>
                      <div class="item__details">
                        <div class="item__details--labels">
                          <p [attr.data-test]="'label-item-quantity'">
                            {{ 'order-thank-you-page.quantity' | translate }}
                          </p>
                          <p [attr.data-test]="'label-item-unitPrice'">
                            {{ 'order-thank-you-page.unit-price' | translate }}
                          </p>
                          @if (isProductVariantsEnabled && item?.housingFeePerUnit) {
                            <p [attr.data-test]="'label-item-housingFeePerUnit'">
                              {{ 'order-thank-you-page.housing-fee-per-unit' | translate }}
                            </p>
                          }
                          <p class="item__details--price" [attr.data-test]="'label-item-totalPrice'">
                            {{ 'order-thank-you-page.total-price' | translate }}
                          </p>
                        </div>
                        <div class="item__details--values text-align-right">
                          <p [attr.data-test]="'desc-item-quantity'">{{ item.quantity }}</p>
                          <p [attr.data-test]="'desc-item-unitPrice'">
                            {{ getItemUnitPrice(item) | currency: orderData.currencyIsoCode }}
                          </p>
                          @if (isProductVariantsEnabled && item?.housingFeePerUnit) {
                            <p [attr.data-test]="'desc-item-housingFeePerUnit'">
                              {{ item.housingFeePerUnit | currency: orderData.currencyIsoCode }}
                            </p>
                          }
                          <p class="item__details--price" [attr.data-test]="'desc-item-totalPrice'">
                            {{ item.sumPrice | currency: orderData.currencyIsoCode }}
                          </p>
                        </div>
                      </div>
                      @if (item.materialMasterNumbers) {
                        <app-advanced-product-information
                            [orderItem]="item"
                            [isEditingEnabled]="false">
                        </app-advanced-product-information>
                      }
                    </div>
                  </div>
                }
              </div>
              <div class="fields">
                <h5 class="title" [attr.data-test]="'title-details'">
                  {{ 'order-thank-you-page.details-title' | translate }}
                </h5>
                @for (field of pageFields; track field) {
                  @switch (field) {
                    @case (EThankYouPageFieldNames.FUNCTIONAL_LOCATION) {
                      <div class="field">
                        <p class="field__title" [attr.data-test]="'label-functionalLocation'">
                          {{ 'order-thank-you-page.functional-location' | translate }}
                        </p>
                        <p class="field__value" [attr.data-test]="'desc-functionalLocation'">
                          {{ orderData.systemDetails?.siemensEquipmentId || '-' }}
                        </p>
                      </div>
                    }
                    @case (EThankYouPageFieldNames.EMAIL) {
                      <div class="field">
                        <p class="field__title" [attr.data-test]="'label-email'">
                          {{ 'order-thank-you-page.email' | translate }}
                        </p>
                        <p class="field__value" [attr.data-test]="'desc-email'">
                          {{ orderData.pointOfContact?.email || '-' }}
                        </p>
                      </div>
                    }
                    @case (EThankYouPageFieldNames.PHONE_NUMBER) {
                      <div class="field">
                        <p class="field__title" [attr.data-test]="'label-phoneNumber'">
                          {{ 'order-thank-you-page.phone-number' | translate }}
                        </p>
                        <p class="field__value" [attr.data-test]="'desc-phoneNumber'">
                          {{ orderData.pointOfContact?.phone || '-' }}
                        </p>
                      </div>
                    }
                    @case (EThankYouPageFieldNames.SHIPMENT_METHOD) {
                      <div class="field">
                        <p class="field__title" [attr.data-test]="'label-shipmentMethod'">
                          {{ 'order-thank-you-page.shipment-method' | translate }}
                        </p>
                        <p class="field__value" [attr.data-test]="'desc-shipmentMethod'">
                          {{ orderData.shipments?.[0]?.shipmentMethodName || '-' }}
                        </p>
                      </div>
                    }
                    @case (EThankYouPageFieldNames.PAYMENT_METHOD) {
                      <div class="field">
                        <p class="field__title" [attr.data-test]="'label-paymentMethod'">
                          {{ 'order-thank-you-page.payment-method' | translate }}
                        </p>
                        <p class="field__value" [attr.data-test]="'desc-paymentMethod'">
                          {{ paymentMethodTranslationKey() | translate }}
                        </p>
                      </div>
                    }
                    @case (EThankYouPageFieldNames.TAX_NUMBER) {
                      <div class="field">
                        <p class="field__title" [attr.data-test]="'label-taxNumber'">
                          {{ 'order-thank-you-page.tax-number' | translate }}
                        </p>
                        <p class="field__value" [attr.data-test]="'desc-taxNumber'">
                          {{ orderData.taxNumber || '-' }}
                        </p>
                      </div>
                    }
                    @case (EThankYouPageFieldNames.PO_NUMBER) {
                      <div class="field">
                        <p class="field__title" [attr.data-test]="'label-purchaseOrder'">
                          {{ 'order-thank-you-page.purchase-order' | translate }}
                        </p>
                        <p class="field__value" [attr.data-test]="'desc-purchaseOrder'">
                          {{ orderData.sapPoNumber || '-' }}
                        </p>
                      </div>
                    }
                    @case (EThankYouPageFieldNames.RETURN_ORDER_NUMBER) {
                      @if (isEligibleForReturn()) {
                        <div class="field">
                          <p class="field__title" [attr.data-test]="'label-returnOrderNumber'">
                            {{ 'order-thank-you-page.return-order-no' | translate }}
                          </p>
                          <p class="field__value" [attr.data-test]="'desc-returnOrderNumber'">
                            {{ orderData.sapDetails?.returnAuthorizationNumber }}
                          </p>
                          <div class="return-document-buttons">
                            @if (isDownloadReturnDocumentEnabled) {
                              <div class="return-document-button">
                                <a (click)="downloadReturnDocument()" [attr.data-test]="'link-downloadReturnDocument'">
                                  <span class="icon-download"></span>
                                  <span>{{ 'order-thank-you-page.download-return-document' | translate }}</span>
                                </a>
                              </div>
                            }
                            @if (isSubmitReturnDocumentEnabled) {
                              <div class="return-document-button">
                                <a [href]="'mailto:' + returnDocumentEmail()"
                                   [attr.data-test]="'link-submitReturnDocument'">
                                  <span class="icon-arrow-right"></span>
                                  <span>{{ 'order-thank-you-page.submit-return-document' | translate }}</span>
                                </a>
                                <p class="return-document-button__label" [attr.data-test]="'desc-submitReturnDocument'">
                                  {{ 'order-thank-you-page.submit-return-document-msg' | translate }}
                                </p>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    }
                    @default {
                      @if (addressFields().has(field)) {
                        <div class="field">
                          <p class="field__title" [attr.data-test]="'label-' + field">
                            {{ 'order-thank-you-page.' + StringUtils.camelToKebab(field) | translate }}
                          </p>
                          <app-address-block
                              class="field__value"
                              [address]="$any(orderData)[AddressUtils.getAddressFieldName(field)]"
                              [attentionTo]="field === EThankYouPageFieldNames.SHIP_TO_ADDRESS ? (orderData.pointOfContact?.attentionTo ?? '') : ''"
                              [attr.data-test]="'desc-' + field">
                          </app-address-block>
                        </div>
                      }
                    }
                  }
                }
              </div>
            </div>
          </ng-container>
        </app-accordion>
      </div>
    </div>
    <div class="page-bottom">
      @if (!isExternalQuoteCheckoutEnabled) {
        <button type="button"
                class="button button--secondary"
                [routerLink]="['/catalog/parts']"
                [attr.data-test]="'button-continueShopping'">
          {{ 'order-thank-you-page.continue-shopping' | translate }}
        </button>
        <button type="button"
                class="button button--primary"
                [routerLink]="['/purchase-activity']"
                [attr.data-test]="'button-viewPurchaseActivity'">
          {{ 'order-thank-you-page.view-purchase-activity' | translate }}
        </button>
      } @else {
        <button type="button"
                class="button button--secondary"
                [attr.data-test]="'button-closeBrowserTab'"
                (click)="window.close()">
          {{ 'order-thank-you-page.close-browser-tab' | translate }}
        </button>
      }
    </div>
  }
</div>
